<template>
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M11.3576 7.93399L11.3609 4.38199L7.9769 4.37882L7.98027 0.778821L4.28427 0.77536L4.2809 4.37536L0.944899 4.37223L0.941573 7.92423L4.27757 7.92736L4.2742 11.5274L7.9702 11.5308L7.97357 7.93082L11.3576 7.93399Z"
            :fill="color" />
    </svg>
</template>

<script>
export default {
    name: "PlusSVG",
    props: {
        color: String
    },
}
</script>